export default __webpack_public_path__ + "static/media/logo.ad07c3cb.png";